export default __webpack_public_path__ + "static/media/sub-img.b628f533.jpg";